import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const invoiceHeaderClassName = css({
  alignItems: 'center',
  display: 'flex',
  position: 'relative',
  padding: `${Spacing.XS}px 0 ${Spacing.LG}px`,
  [SMALL_DEVICE_MQ]: {
    borderBottom: `1px solid ${Colors.LightGray}`,
    padding: Spacing.LG,
  },
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: 18,
  fontWeight: FontWeight.BOLD,
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.REGULAR,
    fontWeight: FontWeight.SEMI_BOLD,
  },
});

export const buttonClassName = css({
  border: `1px solid ${Colors.Gray}`,
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  padding: Spacing.XS,
  position: 'absolute',
  right: 0,
  '&:hover': {
    background: '#F7F7F9',
  },
  [SMALL_DEVICE_MQ]: {
    right: Spacing.LG,
  },
});

export const invoiceBodyClassName = css({
  display: 'grid',
  gap: Spacing.LG,
  paddingTop: Spacing.LG,
  paddingBottom: Spacing.LG,
  [SMALL_DEVICE_MQ]: {
    padding: Spacing.LG,
  },
});

export const invoiceBannerClassName = css({
  alignItems: 'center',
  display: 'flex',
  padding: `${Spacing.XS}px 0`,
  [SMALL_DEVICE_MQ]: {
    padding: `${Spacing.LG}px ${Spacing.LG}px 0`,
  },
});

export const iconClassName = css({
  color: Colors.DarkGreen,
  height: 16,
  width: 16,
});

export const textClassName = css({
  color: Colors.DarkGreen,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  marginLeft: Spacing.XS,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
  },
});

export const invoiceFooterClassName = css({
  padding: `${Spacing.LG}px 0 0`,
  [SMALL_DEVICE_MQ]: {
    padding: `${Spacing.SM}px ${Spacing.LG}px ${Spacing.LG}px`,
  },
});

export const reportButtonClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  padding: 0,
  transition: '0s',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const reportIconClassName = css({
  height: 12,
  width: 12,
});
